"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    track: function() {
        return track;
    },
    identify: function() {
        return identify;
    },
    resetUser: function() {
        return resetUser;
    }
});
var _jsCookie = /*#__PURE__*/ _interopRequireDefault(require("js-cookie"));
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var __generator = (void 0) && (void 0).__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var track = function() {
    var _ref = _asyncToGenerator(function(event, args) {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(window === null || window === void 0 ? void 0 : window.analytics)) return [
                        2
                    ];
                    return [
                        4,
                        window.analytics.track(event, args, {
                            integrations: {
                                //NOTE: We disable the HUbspot integration when we fire custom events since we need an enterprise
                                //      account to see them
                                HubSpot: false
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function track(event, args) {
        return _ref.apply(this, arguments);
    };
}();
var identify = function() {
    var _ref = _asyncToGenerator(function(param) {
        var id, traits, hubSpotPage, hubSpotCategory;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = param.id, traits = param.traits, hubSpotPage = param.hubSpotPage, hubSpotCategory = param.hubSpotCategory;
                    if (!(window === null || window === void 0 ? void 0 : window.analytics)) return [
                        2
                    ];
                    if (!id) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        window.analytics.identify(id, traits)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 2:
                    if (!traits) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        window.analytics.identify(traits)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    throw new Error("Called identify without any id or traits");
                case 5:
                    if (!hubSpotCategory || !hubSpotPage) {
                        console.warn("Called identify wihout page or category");
                        return [
                            2
                        ];
                    }
                    // NOTE: After doing the identify HubSpot requried a Track or a Page call to register the user but since we don't have
                    // an enterprise account we can't really use track so instead we are forced to do a fake "page" call. This is not required
                    // if we now that the user is going to land on another page but since that may or mat not happen the data can easily be lost
                    // if we don't do this
                    return [
                        4,
                        window.analytics.page(hubSpotCategory, hubSpotPage, {}, {
                            integrations: {
                                All: false,
                                HubSpot: true
                            }
                        })
                    ];
                case 6:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function identify(_) {
        return _ref.apply(this, arguments);
    };
}();
var resetUser = function() {
    if (!(window === null || window === void 0 ? void 0 : window.analytics)) return;
    window.analytics.reset();
    // Additionally we remove the Hubspot cookies to prevent it
    // from updating the same user even as logout and login with
    // a different one
    _jsCookie.default.remove("hubspotutk", {
        path: "/",
        domain: window.location.hostname
    });
    _jsCookie.default.remove("__hstc", {
        path: "/",
        domain: window.location.hostname
    });
};

//# sourceMappingURL=segment.js.map